import {
  MP_CATEGORIES_FAILED,
  MP_CATEGORIES_SUCCESS,
  MP_CATEGORIES_INVALID_REQUEST,
  MP_CATEGORIES_NOT_FOUND,
  LOADING_MP_CATEGORIES,
  RESET_MP_CATEGORIES,
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  invalidRequest: false,
  notFound: false,
  categories: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_MP_CATEGORIES:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        invalidRequest: false,
        notFound: false,
      };

    case MP_CATEGORIES_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        invalidRequest: false,
        notFound: false,
      };
    case MP_CATEGORIES_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        notFound: false,
      };

    case MP_CATEGORIES_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        success: true,
        invalidRequest: false,
        failed: false,
        notFound: false,
        categories: action.payload.categories,
      };
    }

    case MP_CATEGORIES_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        notFound: true,
      };

    case RESET_MP_CATEGORIES:
      return (state = initialState);

    default:
      return state;
  }
};
